import script from "./service-soon.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-soon.vue?vue&type=script&lang=ts&setup=true"

import "./service-soon.vue?vue&type=style&index=0&id=120e1392&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120e1392"]])

export default __exports__